var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsTableRaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.327,
    height: 221.428,
    viewBox: "0 0 331.327 221.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3102",
    "data-name": "Group 3102",
    transform: "translate(-1440 -1735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 53.767,
    height: 172.939,
    transform: "translate(1716.995 1783.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 53.767,
    height: 172.939,
    transform: "translate(1662.995 1783.489)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4.9_4.9_4.8_4.9_4.9",
    "data-name": "4.9 4.9 4.8 4.9 4.9",
    transform: "translate(1688 1806.581)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.317,
    y: 0
  }, "4.9"), /*#__PURE__*/React.createElement("tspan", {
    x: -8.317,
    y: 34.5
  }, "4.9"), /*#__PURE__*/React.createElement("tspan", {
    x: -8.317,
    y: 69
  }, "4.8"), /*#__PURE__*/React.createElement("tspan", {
    x: -8.317,
    y: 103.5
  }, "4.9"), /*#__PURE__*/React.createElement("tspan", {
    x: -8.317,
    y: 138
  }, "4.9")), /*#__PURE__*/React.createElement("text", {
    id: "_263_205_175_169_100",
    "data-name": "263 205 175 169 100",
    transform: "translate(1744 1806.581)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 0
  }, "263"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 34.5
  }, "205"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 69
  }, "175"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 103.5
  }, "169"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 138
  }, "100")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 53.67,
    height: 32.593,
    transform: "translate(1716.995 1752.328)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M0,0H53.67V32.593H0Z",
    transform: "translate(1662.995 1752.328)",
    fill: "#e27867",
    opacity: 0.497
  }), /*#__PURE__*/React.createElement("text", {
    id: "River_City_Dental",
    "data-name": "River City Dental",
    transform: "translate(1452.696 1944.75)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "River City Dental")), /*#__PURE__*/React.createElement("text", {
    id: "_392",
    "data-name": 392,
    transform: "translate(1744 1771.841)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.327,
    y: 0
  }, "392")), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M0,0H330.934V204.793H0Z",
    transform: "translate(1440.268 1751.488)",
    fill: "none",
    stroke: "#babcbf",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "Total_",
    "data-name": "Total #",
    transform: "translate(1744 1744)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.354,
    y: 0
  }, "TOTAL #")), /*#__PURE__*/React.createElement("text", {
    id: "Avg._Rating",
    "data-name": "Avg. Rating",
    transform: "translate(1688 1744)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.976,
    y: 0
  }, "AVG. RATING")), /*#__PURE__*/React.createElement("text", {
    id: "Riverton_Heights_Dental_Care",
    "data-name": "Riverton Heights Dental Care",
    transform: "translate(1468.033 1772.581)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Riverton Heights Dental Care")), /*#__PURE__*/React.createElement("text", {
    id: "Stone_Creek_Family_Dental",
    "data-name": "Stone Creek Family Dental",
    transform: "translate(1467.764 1805.179)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Stone Creek Family Dental")), /*#__PURE__*/React.createElement("text", {
    id: "Riverton_Dental",
    "data-name": "Riverton Dental",
    transform: "translate(1451.764 1839.778)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Riverton Dental")), /*#__PURE__*/React.createElement("text", {
    id: "Abundant_Dental_Care_and_Implants",
    "data-name": "Abundant Dental Care and Implants",
    transform: "translate(1451.764 1875.376)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abundant Dental Care and Implants")), /*#__PURE__*/React.createElement("text", {
    id: "Silver_Ridge_Dental_Care",
    "data-name": "Silver Ridge Dental Care",
    transform: "translate(1451.764 1908.975)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Silver Ridge Dental Care")), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 330.971,
    transform: "translate(1440.231 1786.418)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x2: 330.971,
    transform: "translate(1440.231 1820.945)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x2: 330.971,
    transform: "translate(1440.231 1855.472)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x2: 330.971,
    transform: "translate(1440.231 1889.998)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x2: 330.971,
    transform: "translate(1440.231 1924.998)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 4.648,
    cy: 4.648,
    r: 4.648,
    transform: "translate(1452.875 1797.049)",
    fill: "#98c3ac"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 4.648,
    cy: 4.648,
    r: 4.648,
    transform: "translate(1452.875 1763.495)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_5.0",
    "data-name": 5,
    transform: "translate(1688 1772.354)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.628,
    y: 0
  }, "5.0")), /*#__PURE__*/React.createElement("text", {
    id: "Competitors:",
    transform: "translate(1442.372 1744)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COMPETITORS:")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    transform: "translate(1440 1752)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 330,
    height: 33,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsTableRaw);
export default __webpack_public_path__ + "static/media/reviewsTableRaw.4e64fce4.svg";
export { ForwardRef as ReactComponent };